import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { summaryPromptsActions } from "./summary-prompts.actions";
import { of, switchMap } from "rxjs";
import { PromptSdk } from "@sdks/prompt.sdk";

@Injectable()
export class SummaryPromptsEffects {

    public load$ = createEffect(() => this.actions$.pipe(
        ofType(summaryPromptsActions.loadPrompts),
        switchMap(() => this.promptSdk.getSummaryPrompt().pipe(
            switchMap((data) => {
                if (data)
                    return of(summaryPromptsActions.loadedPrompts({ summaryPrompts: data }));
                return of(summaryPromptsActions.loadedPrompts({ summaryPrompts: [] }));
            }))
        )
    ));

    constructor(
        private actions$: Actions,
        private promptSdk: PromptSdk) { }
}

